export function getApiBaseUrl(): string {
  const envUrl = process.env.NEXT_PUBLIC_API_URL
  if (envUrl) return envUrl.replace(/\/+$/, "")
  if (typeof window === "undefined") return "http://localhost:8000"
  return window.location.hostname.includes("promobot.cloud")
    ? "https://api.promobot.cloud"
    : "http://localhost:8000"
}

export function apiUrl(): string {
  return `${getApiBaseUrl()}/api`
}

function getTenantDomain(): string {
  if (typeof window === "undefined") return ""
  return window.location.hostname
}

export function authHeaders(token: string | null): Record<string, string> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "X-Tenant-Domain": getTenantDomain(),
  }
  if (token) headers.Authorization = `Bearer ${token}`
  return headers
}

export function publicHeaders(): Record<string, string> {
  return {
    "Content-Type": "application/json",
    "X-Tenant-Domain": getTenantDomain(),
  }
}

export function timeAgo(iso?: string | null): string {
  if (!iso) return "Nunca"
  const diff = Date.now() - new Date(iso).getTime()
  const min = Math.floor(diff / 60000)
  if (min < 1) return "agora"
  if (min < 60) return `${min}min atrás`
  const h = Math.floor(min / 60)
  if (h < 24) return `${h}h atrás`
  return `${Math.floor(h / 24)}d atrás`
}
